import React, { useState, useEffect } from 'react';
import { ArrowRight, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useBooking } from '../contexts/BookingContext';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/kviu8y7r_45534c89ec39ab5c3735a2ef1732c0a8.jpg";
const PRICE_LIST_IMAGE = "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/5j6ytehs_IMG-20260130-WA0022.jpg";

// Hairstyle Catalog Data
const hairstyleCatalog = [
  {
    id: 'butterfly_locs',
    name_en: 'Butterfly Locs',
    name_pt: 'Butterfly Locs',
    name_fr: 'Butterfly Locs',
    name_de: 'Butterfly Locs',
    name_es: 'Butterfly Locs',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/r2j9bfpa_539e363da76b58a7ee679be4c572954e.jpg',
    description_en: 'Soft, distressed locs with a bohemian flair',
    description_fr: 'Locs souples et décontractées avec une touche bohème',
    description_pt: 'Locs macias e descontraídas com um toque boêmio',
    description_de: 'Weiche, entspannte Locs mit bohemischem Flair',
    description_es: 'Locs suaves y relajados con estilo bohemio'
  },
  {
    id: 'goddess_braids',
    name_en: 'Goddess Braids',
    name_pt: 'Goddess Braids',
    name_fr: 'Tresses Déesse',
    name_de: 'Goddess Braids',
    name_es: 'Trenzas Diosa',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/9o5id2fw_9d059832c72bdbb4a146f23d6ad14010.jpg',
    description_en: 'Elegant long braids with beautiful curly waves',
    description_fr: 'Élégantes longues tresses avec de belles ondulations bouclées',
    description_pt: 'Elegantes tranças longas com lindas ondas cacheadas',
    description_de: 'Elegante lange Zöpfe mit schönen lockigen Wellen',
    description_es: 'Elegantes trenzas largas con hermosas ondas rizadas'
  },
  {
    id: 'passion_twists',
    name_en: 'Passion Twists',
    name_pt: 'Passion Twists',
    name_fr: 'Passion Twists',
    name_de: 'Passion Twists',
    name_es: 'Passion Twists',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/l56sxwuv_7f3d0fb8a250011bcba880859bda45fe.jpg',
    description_en: 'Bohemian twists with a natural curly finish',
    description_fr: 'Torsades bohèmes avec une finition bouclée naturelle',
    description_pt: 'Torções boêmias com acabamento cacheado natural',
    description_de: 'Bohemische Twists mit natürlichem lockigem Finish',
    description_es: 'Twist bohemios con acabado rizado natural'
  },
  {
    id: 'boho_braids',
    name_en: 'Boho Braids',
    name_pt: 'Tranças Boho',
    name_fr: 'Tresses Boho',
    name_de: 'Boho Zöpfe',
    name_es: 'Trenzas Boho',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/lwnfsiez_be0badaccd499290308ee71b7c7cfe5d.jpg',
    description_en: 'Box braids with gorgeous curly ends',
    description_fr: 'Box braids avec de superbes pointes bouclées',
    description_pt: 'Box braids com lindas pontas cacheadas',
    description_de: 'Box Braids mit wunderschönen lockigen Enden',
    description_es: 'Box braids con hermosas puntas rizadas'
  },
  {
    id: 'cornrows_art',
    name_en: 'Artistic Cornrows',
    name_pt: 'Cornrows Artísticas',
    name_fr: 'Cornrows Artistiques',
    name_de: 'Künstlerische Cornrows',
    name_es: 'Cornrows Artísticas',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/dz11k61f_caddf521d320c60e34ee2dca2baf5585.jpg',
    description_en: 'Intricate geometric patterns close to the scalp',
    description_fr: 'Motifs géométriques complexes près du cuir chevelu',
    description_pt: 'Padrões geométricos intrincados junto ao couro cabeludo',
    description_de: 'Aufwendige geometrische Muster nahe der Kopfhaut',
    description_es: 'Patrones geométricos intrincados cerca del cuero cabelludo'
  },
  {
    id: 'fulani_braids',
    name_en: 'Fulani Braids',
    name_pt: 'Tranças Fulani',
    name_fr: 'Tresses Fulani',
    name_de: 'Fulani Zöpfe',
    name_es: 'Trenzas Fulani',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/zvm9dv4q_53e8b83b82ad5ffe933fafda5373a04a.jpg',
    description_en: 'Traditional African style with beads and accessories',
    description_fr: 'Style africain traditionnel avec perles et accessoires',
    description_pt: 'Estilo africano tradicional com contas e acessórios',
    description_de: 'Traditioneller afrikanischer Stil mit Perlen und Accessoires',
    description_es: 'Estilo africano tradicional con cuentas y accesorios'
  },
  {
    id: 'knotless_braids',
    name_en: 'Knotless Braids',
    name_pt: 'Knotless Braids',
    name_fr: 'Tresses Sans Nœuds',
    name_de: 'Knotless Braids',
    name_es: 'Trenzas Sin Nudos',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/0zqn3zfu_fd54a1e75da058fd9c67dbb05de42235.jpg',
    description_en: 'Lightweight long braids without tension at the root',
    description_fr: 'Longues tresses légères sans tension à la racine',
    description_pt: 'Tranças longas e leves sem tensão na raiz',
    description_de: 'Leichte lange Zöpfe ohne Spannung an der Wurzel',
    description_es: 'Trenzas largas y ligeras sin tensión en la raíz'
  },
  {
    id: 'tribal_braids',
    name_en: 'Tribal Braids',
    name_pt: 'Tranças Tribais',
    name_fr: 'Tresses Tribales',
    name_de: 'Tribal Zöpfe',
    name_es: 'Trenzas Tribales',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/ik0m91cl_ee9e39a46b66e89b01b474121a78ae40.jpg',
    description_en: 'Creative tribal patterns with artistic top design',
    description_fr: 'Motifs tribaux créatifs avec design artistique au sommet',
    description_pt: 'Padrões tribais criativos com design artístico no topo',
    description_de: 'Kreative Stammesmuster mit künstlerischem Top-Design',
    description_es: 'Patrones tribales creativos con diseño artístico superior'
  },
  {
    id: 'water_wave',
    name_en: 'Water Wave Braids',
    name_pt: 'Tranças Ondas',
    name_fr: 'Tresses Ondulées',
    name_de: 'Wellen Zöpfe',
    name_es: 'Trenzas Onduladas',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/q5hw404e_23f1abe691ca6adebe8d33b6e2dc12da.jpg',
    description_en: 'Bohemian braids with beautiful wavy curls',
    description_fr: 'Tresses bohèmes avec de magnifiques boucles ondulées',
    description_pt: 'Tranças boêmias com lindas ondas cacheadas',
    description_de: 'Bohemische Zöpfe mit wunderschönen welligen Locken',
    description_es: 'Trenzas bohemias con hermosos rizos ondulados'
  },
  {
    id: 'kids_cornrows',
    name_en: 'Kids Cornrows',
    name_pt: 'Cornrows Infantis',
    name_fr: 'Cornrows Enfants',
    name_de: 'Kinder Cornrows',
    name_es: 'Cornrows Niños',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/bjqfwrc2_76f8da9cd68d08138fd449253c09bacf.jpg',
    description_en: 'Adorable braided styles for children with heart design',
    description_fr: 'Adorables styles tressés pour enfants avec motif cœur',
    description_pt: 'Estilos de tranças adoráveis para crianças com design de coração',
    description_de: 'Entzückende geflochtene Stile für Kinder mit Herzdesign',
    description_es: 'Estilos de trenzas adorables para niños con diseño de corazón'
  },
  {
    id: 'senegalese_twists',
    name_en: 'Senegalese Twists',
    name_pt: 'Torsões Senegalesas',
    name_fr: 'Tresses Sénégalaises',
    name_de: 'Senegalese Twists',
    name_es: 'Trenzas Senegalesas',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/kdrhn5nv_8ca37797fab0c1661fcda537adc3941d.jpg',
    description_en: 'Sleek rope-like twists with elegant finish',
    description_fr: 'Torsades élégantes en forme de corde avec finition soignée',
    description_pt: 'Torções elegantes em forma de corda com acabamento refinado',
    description_de: 'Elegante seilartige Twists mit elegantem Finish',
    description_es: 'Torsiones elegantes tipo cuerda con acabado refinado'
  },
  {
    id: 'bantu_knots',
    name_en: 'Bantu Knots',
    name_pt: 'Nós Bantu',
    name_fr: 'Nœuds Bantu',
    name_de: 'Bantu Knoten',
    name_es: 'Nudos Bantu',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/2fgox1hs_982c71e6e877d0a7e648f50c44a50cc2.jpg',
    description_en: 'Traditional African style with coiled knots',
    description_fr: 'Style africain traditionnel avec nœuds enroulés',
    description_pt: 'Estilo africano tradicional com nós enrolados',
    description_de: 'Traditioneller afrikanischer Stil mit gewickelten Knoten',
    description_es: 'Estilo africano tradicional con nudos enrollados'
  },
  {
    id: 'faux_locs',
    name_en: 'Faux Locs',
    name_pt: 'Faux Locs',
    name_fr: 'Faux Locs',
    name_de: 'Faux Locs',
    name_es: 'Faux Locs',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/nabe2s21_55ca6b79d721fc31dc29858b2337de89.jpg',
    description_en: 'Long textured faux locs with natural look',
    description_fr: 'Longues faux locs texturées avec un look naturel',
    description_pt: 'Faux locs longas e texturizadas com visual natural',
    description_de: 'Lange strukturierte Faux Locs mit natürlichem Look',
    description_es: 'Faux locs largos y texturizados con aspecto natural'
  },
  {
    id: 'burgundy_braids',
    name_en: 'Burgundy Bohemian Braids',
    name_pt: 'Tranças Bohemian Bordô',
    name_fr: 'Tresses Bohème Bordeaux',
    name_de: 'Burgundy Bohemian Zöpfe',
    name_es: 'Trenzas Bohemian Burdeos',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/egieahv4_3184de1890de29c7646396b043027f24.jpg',
    description_en: 'Stunning burgundy braids with curly bohemian ends',
    description_fr: 'Superbes tresses bordeaux avec pointes bouclées bohèmes',
    description_pt: 'Lindas tranças bordô com pontas cacheadas boêmias',
    description_de: 'Atemberaubende burgunderfarbene Zöpfe mit lockigen bohemischen Enden',
    description_es: 'Hermosas trenzas burdeos con puntas rizadas bohemias'
  },
  {
    id: 'box_braids_ombre',
    name_en: 'Box Braids Ombré',
    name_pt: 'Box Braids Ombré',
    name_fr: 'Box Braids Ombré',
    name_de: 'Box Braids Ombré',
    name_es: 'Box Braids Ombré',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/3ct24qmf_d5072b934ff57b94fc8278df20862b5b.jpg',
    description_en: 'Classic box braids with beautiful ombre color transition',
    description_fr: 'Box braids classiques avec une belle transition de couleur ombré',
    description_pt: 'Box braids clássicas com linda transição de cor ombré',
    description_de: 'Klassische Box Braids mit schönem Ombré-Farbübergang',
    description_es: 'Box braids clásicas con hermosa transición de color ombré'
  },
  {
    id: 'mens_braids',
    name_en: "Men's Braids",
    name_pt: 'Tranças Masculinas',
    name_fr: 'Tresses Homme',
    name_de: 'Männer Zöpfe',
    name_es: 'Trenzas Masculinas',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/axg9pasx_f5b60410bdcfb4e082121747ce3bb7bf.jpg',
    description_en: 'Stylish braids for men with clean fade',
    description_fr: 'Tresses élégantes pour hommes avec dégradé soigné',
    description_pt: 'Tranças elegantes para homens com degradê limpo',
    description_de: 'Stilvolle Zöpfe für Männer mit sauberem Fade',
    description_es: 'Trenzas elegantes para hombres con degradado limpio'
  },
  {
    id: 'hair_treatment',
    name_en: 'Hair Treatment & Straightening',
    name_pt: 'Tratamento Capilar & Alisamento',
    name_fr: 'Traitement Capillaire & Lissage',
    name_de: 'Haarbehandlung & Glättung',
    name_es: 'Tratamiento Capilar & Alisado',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/x4k3znin_efe9ba038cad39d88f43100ebe1500c3.jpg',
    description_en: 'Professional hair treatment with stunning before/after results',
    description_fr: 'Traitement capillaire professionnel avec des résultats avant/après époustouflants',
    description_pt: 'Tratamento capilar profissional com resultados antes/depois impressionantes',
    description_de: 'Professionelle Haarbehandlung mit atemberaubenden Vorher/Nachher-Ergebnissen',
    description_es: 'Tratamiento capilar profesional con impresionantes resultados antes/después'
  },
  {
    id: 'hair_extensions',
    name_en: 'Hair Extensions',
    name_pt: 'Extensões de Cabelo',
    name_fr: 'Extensions de Cheveux',
    name_de: 'Haarverlängerungen',
    name_es: 'Extensiones de Cabello',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/ng24uy1f_cdb61b1fcf4a2d6d56bf197ae8faa579.jpg',
    description_en: 'Premium quality hair extensions for length and volume',
    description_fr: 'Extensions de cheveux de qualité premium pour longueur et volume',
    description_pt: 'Extensões de cabelo de qualidade premium para comprimento e volume',
    description_de: 'Premium-Qualität Haarverlängerungen für Länge und Volumen',
    description_es: 'Extensiones de cabello de calidad premium para longitud y volumen'
  },
  {
    id: 'curly_bob_braids',
    name_en: 'Curly Bob Braids',
    name_pt: 'Tranças Bob Cacheadas',
    name_fr: 'Tresses Bob Bouclées',
    name_de: 'Lockige Bob Zöpfe',
    name_es: 'Trenzas Bob Rizadas',
    image: 'https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/7mq9r7vp_32745d752e78a8b82be392ee70794ea1.jpg',
    description_en: 'Short curly box braids with beautiful curly ends',
    description_fr: 'Courtes box braids avec de belles pointes bouclées',
    description_pt: 'Box braids curtas com lindas pontas cacheadas',
    description_de: 'Kurze lockige Box Braids mit schönen lockigen Enden',
    description_es: 'Box braids cortas con hermosas puntas rizadas'
  }
];

const AfroHairPage = () => {
  const { language, t } = useLanguage();
  const { openBooking } = useBooking();
  const [services, setServices] = useState({});
  const [loading, setLoading] = useState(true);

  const getTitle = (item) => {
    switch(language) {
      case 'fr': return item.name_fr || item.name_en;
      case 'de': return item.name_de || item.name_en;
      case 'pt': return item.name_pt || item.name_en;
      case 'es': return item.name_es || item.name_en;
      default: return item.name_en;
    }
  };

  const getDescription = (item) => {
    const descKey = `description_${language}`;
    return item[descKey] || item.description_en || '';
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API}/services`);
        setServices(response.data);
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <div className="min-h-screen bg-kamit-beige pt-20" data-testid="afro-hair-page">
      {/* Hero */}
      <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Afro Hair Studio"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-kamit-dark/70 via-kamit-dark/50 to-kamit-dark/80" />
        </div>
        <div className="relative z-10 text-center px-4">
          <p 
            className="text-kamit-gold text-2xl md:text-4xl mb-4 tracking-[0.3em] font-medium"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            I.P.R.B.C. KAMIT
          </p>
          <h1 className="font-heading text-5xl md:text-7xl text-kamit-beige mb-4">
            Afro Hair Studio
          </h1>
          <p className="text-kamit-beige/80 text-lg max-w-2xl mx-auto mb-8">
            {language === 'pt'
              ? 'Especialistas em tranças africanas, extensões e tratamentos capilares afro'
              : language === 'fr'
              ? 'Spécialistes en tresses africaines, extensions et traitements capillaires afro'
              : language === 'de'
              ? 'Spezialisten für afrikanische Zöpfe, Extensions und Afro-Haarbehandlungen'
              : language === 'es'
              ? 'Especialistas en trenzas africanas, extensiones y tratamientos capilares afro'
              : 'Specialists in African braids, extensions and afro hair treatments'
            }
          </p>
          <Button 
            onClick={() => openBooking('afro_braids')}
            className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg btn-shine"
            data-testid="afro-hero-book-btn"
          >
            {t('nav_book')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>

      {/* Services */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-4xl text-kamit-brown mb-4">
              {language === 'pt' ? 'Os Nossos Serviços' 
               : language === 'fr' ? 'Nos Services'
               : language === 'de' ? 'Unsere Dienstleistungen'
               : language === 'es' ? 'Nuestros Servicios'
               : 'Our Services'}
            </h2>
            <div className="w-24 h-1 bg-kamit-gold mx-auto" />
          </div>

          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin h-8 w-8 border-4 border-kamit-gold border-t-transparent rounded-full mx-auto" />
            </div>
          ) : (
            <Tabs defaultValue="braids">
              <TabsList className="flex flex-wrap justify-center gap-2 bg-transparent mb-12">
                <TabsTrigger
                  value="braids"
                  className="px-6 py-3 rounded-full data-[state=active]:bg-kamit-brown data-[state=active]:text-kamit-beige text-kamit-brown border border-kamit-brown/20"
                  data-testid="tab-braids"
                >
                  {language === 'pt' ? 'Tranças' 
                   : language === 'fr' ? 'Tresses'
                   : language === 'de' ? 'Zöpfe'
                   : language === 'es' ? 'Trenzas'
                   : 'Braids'}
                </TabsTrigger>
                <TabsTrigger
                  value="treatments"
                  className="px-6 py-3 rounded-full data-[state=active]:bg-kamit-brown data-[state=active]:text-kamit-beige text-kamit-brown border border-kamit-brown/20"
                  data-testid="tab-treatments"
                >
                  {language === 'pt' ? 'Tratamentos' 
                   : language === 'fr' ? 'Traitements'
                   : language === 'de' ? 'Behandlungen'
                   : language === 'es' ? 'Tratamientos'
                   : 'Treatments'}
                </TabsTrigger>
              </TabsList>

              <TabsContent value="braids">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {services.afro_braids?.map((service) => (
                    <div
                      key={service.id}
                      className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all border border-kamit-brown/5 group"
                      data-testid={`braid-${service.id}`}
                    >
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="font-heading text-xl text-kamit-brown group-hover:text-kamit-gold transition-colors">
                          {getTitle(service)}
                        </h3>
                      </div>
                      <p className="text-kamit-gold font-semibold text-lg">
                        {service.price}
                      </p>
                    </div>
                  ))}
                </div>
              </TabsContent>

              <TabsContent value="treatments">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {services.afro_treatments?.map((service) => (
                    <div
                      key={service.id}
                      className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all border border-kamit-brown/5 group"
                      data-testid={`treatment-${service.id}`}
                    >
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="font-heading text-xl text-kamit-brown group-hover:text-kamit-gold transition-colors">
                          {getTitle(service)}
                        </h3>
                      </div>
                      <p className="text-kamit-gold font-semibold text-lg">
                        {service.price}
                      </p>
                    </div>
                  ))}
                </div>
              </TabsContent>
            </Tabs>
          )}
        </div>
      </section>

      {/* Hairstyle Catalog */}
      <section className="py-20 bg-white" data-testid="hairstyle-catalog">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-4xl text-kamit-brown mb-4">
              {language === 'pt' ? 'Catálogo de Penteados' : language === 'fr' ? 'Catalogue de Coiffures' : language === 'de' ? 'Frisurenkatalog' : language === 'es' ? 'Catálogo de Peinados' : 'Hairstyle Catalog'}
            </h2>
            <p className="text-kamit-brown/70 max-w-2xl mx-auto">
              {language === 'pt' 
                ? 'Descubra os nossos estilos mais populares e encontre a inspiração perfeita para o seu próximo look'
                : language === 'fr'
                ? 'Découvrez nos styles les plus populaires et trouvez l\'inspiration parfaite pour votre prochain look'
                : language === 'de'
                ? 'Entdecken Sie unsere beliebtesten Stile und finden Sie die perfekte Inspiration für Ihren nächsten Look'
                : language === 'es'
                ? 'Descubre nuestros estilos más populares y encuentra la inspiración perfecta para tu próximo look'
                : 'Discover our most popular styles and find the perfect inspiration for your next look'
              }
            </p>
            <div className="w-24 h-1 bg-kamit-gold mx-auto mt-4" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {hairstyleCatalog.map((style) => (
              <div
                key={style.id}
                className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
                data-testid={`hairstyle-${style.id}`}
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={style.image}
                    alt={getTitle(style)}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-kamit-dark/90 via-kamit-dark/20 to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                  <h3 className="font-heading text-lg md:text-xl mb-1">
                    {getTitle(style)}
                  </h3>
                  <p className="text-sm text-white/80 line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {getDescription(style)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button 
              onClick={() => openBooking('afro_braids')}
              className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg btn-shine"
              data-testid="afro-catalog-book-btn"
            >
              {language === 'pt' ? 'Reservar Agora' : language === 'fr' ? 'Réserver Maintenant' : language === 'de' ? 'Jetzt Buchen' : language === 'es' ? 'Reservar Ahora' : 'Book Now'}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Price List / Menu Section */}
      <section className="py-16 bg-kamit-brown/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="font-heading text-3xl text-kamit-brown mb-4">
              {language === 'fr' ? 'Notre Preçário' : language === 'pt' ? 'Nosso Preçário' : 'Our Price List'}
            </h2>
            <div className="w-24 h-1 bg-kamit-gold mx-auto" />
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <img 
              src={PRICE_LIST_IMAGE}
              alt="Afro Hair Price List"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-kamit-brown">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-4xl text-kamit-beige mb-4">
            {language === 'pt' ? 'Pronta para um Novo Look?' : 'Ready for a New Look?'}
          </h2>
          <p className="text-kamit-beige/70 mb-8 text-lg">
            {language === 'pt'
              ? 'Os nossos especialistas estão prontos para transformar o seu cabelo.'
              : 'Our specialists are ready to transform your hair.'
            }
          </p>
          <Button 
            onClick={() => openBooking('afro_braids')}
            className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-10 py-6 text-lg btn-shine"
            data-testid="afro-cta-book-btn"
          >
            {t('nav_book')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>
    </div>
  );
};

export default AfroHairPage;
